import React, { useState } from 'react';
import { Modal, Button, Spinner, Container, Row, Col } from 'react-bootstrap';
import bg2 from '../../assets/bg-2.svg';
import boxImg from '../../assets/box-img.webp';
import EmailService from "../../service/EmailService";

const Footer = () => {

  const [formData, setFormData] = useState({
    name: 'Newsletter Subscription',
    email: '',
    phone: '0000000000',
    formMessage: '',
  });
  const [message, setMessage] = useState({ text: '', variant: '' });
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: '', variant: '' });

    const currentTimestamp = new Date().toISOString();
    const subscriptionMessage = `Newsletter subscription request from TruckRepairShop at : ${currentTimestamp}`;

    try {
      const response = await EmailService.sendEmail({ ...formData, formMessage: subscriptionMessage });
      setMessage({ text: response, variant: 'success' });
      setFormData({ name: 'Newsletter Subscription', email: '', phone: '0000000000', formMessage: '' });
    } catch (error) {
      setMessage({ text: `Error: ${error.message}`, variant: 'danger' });
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  };

  return (<>

    <footer className="text-white">
      <Container>

        <Row>
        <form onSubmit={handleSubmit}>
           <div className="row justify-content-center news_letter_row align-items-center">
            <div className='col-lg-5 col-md-6'>
              <div className='news_title'>
              <h4>Subscribe to our newsletter!</h4>
              <p>Let me know if you'd like to tweak it further!</p>
              </div>
            </div>

            <div className="col-md-4 px-md-0 px-3">
              <div className="form-group news_input mb-0">
                 <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  required
                  disabled={loading}
                  />
              </div>
            </div>

            <div className="col-md-2 px-md-0 px-3">
                 <button type="submit" className="btn news_btn" disabled={loading}>
                     {loading ? (
                        <>
                           <Spinner animation="border" size="sm" role="status" className="me-2" />
                           Subscribe
                        </>
                     ) : (
                        'Subscribe'
                     )}
                  </button>
            </div>
           </div>
           </form>
          </Row>


          <Row className='justify-content-center'>
          <Col className='foot_text my-md-4 my-3' lg={3} md={5}>
            <h4>Company</h4>
            <ul>
              <li><a href="/" className="text-white">Home</a></li>
              <li><a href="/plans" className="text-white">Plans</a></li>
              <li><a href="/about" className="text-white">About Us</a></li>
              <li><a href="/contact" className="text-white">Contact Us</a></li>
            </ul>
          </Col>

          <Col className='foot_text my-md-4 my-3' lg={3} md={5}>
            <h4>Useful Links</h4>
            <ul>
              <li><a href="/blogs" className="text-white">Blog</a></li>
              <li><a href="/privacypolicy" className="text-white">Privacy Policy</a></li>
              <li><a href="/termsandcondition" className="text-white">Terms & Conditions</a></li>
              <li><a href="/refundandcancellation" className="text-white">Refund & Cancellation</a></li>
            </ul>
          </Col>

          <Col className='contact-detail my-md-4 my-3' lg={3} md={5}>
          <h4>Contact Info</h4>
          <ul className="contact-list">
            <li><a href="tel:+18008057820"><i className="fa fa-phone" title="Phone"></i> +1 (800) 805-7820</a></li>
            <li><a href="mailto:contact@truckrepairshop.net"><i className="fa fa-envelope" title="Email"></i> contact@truckrepairshop.net</a></li>
          </ul>

          </Col>

          <Col className='social-icon my-md-4 my-3' lg={3} md={5}>
          <h4>Social Links</h4>
          <ul>
          <li><a href="https://www.facebook.com/truckrepairshop.net/" target="_blank"><i className="fab fa-facebook-square" title="facebook"></i></a></li>
          <li><a href="https://www.instagram.com/truckrepairshop_/" target="_blank"><i className="fab fa-instagram" title="instagram"></i></a></li>
          <li><a href="https://www.pinterest.com/contacttruckrepairshop/" target="_blank"><i className="fab fa-pinterest" title="pinterest"></i></a></li>
          <li><a href="https://x.com/truck80031" target="_blank"><i className="fab fa-x-twitter" title="twitter"></i></a></li>
          <li><a href="https://www.youtube.com/channel/UCX8Z-mQyTY-FgFaz_DOLY3w" target="_blank"><i className="fab fa-youtube" title="youtube"></i></a></li>
          </ul>
          </Col>
          <Col md={12}>
          <hr/>
          </Col>

          <Col md={12} className="text-center mt-2 copy-right">
            <p>&copy; 2022- {new Date().getFullYear()} TruckRepairShop. All Rights Reserved. Powered By Breakdown Inc</p>
          </Col>

        </Row>

      </Container>
    </footer>

    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header className='py-2' closeButton>
          <Modal.Title><strong>{message.variant === 'success' ? 'Subscribed Successfully!' : 'Error'}</strong></Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center my-md-3">
          {message.variant === 'success' ? (
            <>
              <p className="text-success mb-0">😊 Thank you for subscribing! </p>
            </>
          ) : (
            <>
              <p className="text-danger mb-0">❌ {message.text}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Footer;
